import { ACTION_STATES, ComplexAction, createHandler, createReducer, DefaultAction } from "core/actions";
import log from "loglevel";

export const initState = {
    filmRelease: null,
    inModal: true,
    open: false,
    editing: false,
    id: null,
    values: null,
    loadStatus: ACTION_STATES.NO_REQUEST,
    addStatus: ACTION_STATES.NO_REQUEST,
    editStatus: ACTION_STATES.NO_REQUEST,
    callback: null,
    mergingStatus: ACTION_STATES.NO_REQUEST,
    associationStatus: ACTION_STATES.NO_REQUEST,
    creatingNew: ACTION_STATES.NO_REQUEST,
};

export class ON_LOAD_FILM extends ComplexAction {
    sendRdx(state, { payload }) {
        // eslint-disable-next-line no-prototype-builtins
        const inModal = payload.hasOwnProperty("inModal") ? payload.inModal : true;
        return Object.assign(state, {
            filmRelease: null,
            loadStatus: ACTION_STATES.SUCCESS,
            inModal,
        });
    }

    successRdx(state, { payload }) {
        return Object.assign(state, {
            filmRelease: payload.filmRelease,
            loadStatus: ACTION_STATES.SUCCESS,
        });
    }
}

export class TOGGLE_FILM_RELEASE_FORM extends ComplexAction {
    constructor() {
        const props = {
            error: false,
        };
        super(null, props);
    }
    sendRdx(state, { payload }) {
        const { reopen } = payload;
        const open = reopen ? reopen : !state.open;
        return {
            ...state,
            open,
            editing: payload && payload.editing,
            id: payload && payload.id,
            loadStatus: payload && payload.editing && ACTION_STATES.SEND,
        };
    }
    successRdx(state, { payload }) {
        return {
            ...state,
            values: payload ? payload.data : null,
            loadStatus: payload && ACTION_STATES.SUCCESS,
        };
    }
}

export class ADD_FILM_RELEASE extends ComplexAction {
    constructor() {
        const props = {
            loadingAtr: "addStatus",
        };
        super(props);
    }

    sendRdx(state, { payload }) {
        log.debug("[ADD_FILM_RELEASE] sendRdx", state, payload);

        return {
            ...state,
            addStatus: ACTION_STATES.SEND,
            values: payload.values,
            callback: payload.callback,
        };
    }
    successRdx(state) {
        return Object.assign({}, state, {
            addStatus: ACTION_STATES.SUCCESS,
            open: false,
            editing: false,
            values: null,
        });
    }
}
export class EDIT_FILM_RELEASE extends ComplexAction {
    constructor() {
        const props = {
            loadingAtr: "editStatus",
        };
        super(props);
    }

    sendRdx(state, { payload }) {
        log.debug("[EDIT_FILM_RELEASE] sendRdx", state, payload);

        return {
            ...state,
            editStatus: ACTION_STATES.SEND,
            values: payload.values,
            callback: payload.callback,
        };
    }
    successRdx(state, { payload }) {
        log.debug("[EDIT_FILM_RELEASE] successRdx", state, payload);
        return Object.assign({}, state, {
            editStatus: ACTION_STATES.SUCCESS,
            open: false,
            editing: false,
            values: null,
        });
    }
}

export class MERGE_FILM_RELEASE extends ComplexAction {
    successRdx(state, { payload }) {
        return {
            ...state,
            values: payload ? payload.data : null,
            mergingStatus: ACTION_STATES.SUCCESS,
        };
    }
}

export class ASSOCIATION_FILM_RELEASE extends ComplexAction {
    successRdx(state, { payload }) {
        return {
            ...state,
            values: payload ? payload.data : null,
            associationStatus: ACTION_STATES.SUCCESS,
        };
    }
}
export class ON_CREATE_FORM_EXISTING extends DefaultAction {
    callRdx(state) {
        const filmRelease = {
            ...state.filmRelease,
            id: null,
        };
        return Object.assign({}, state, {
            editing: false,
            filmRelease,
        });
    }
}
export class ADD_FROM_EXITING_FILM_RELEASE extends ComplexAction {}
export const actions = {
    EDIT_FILM_RELEASE: new EDIT_FILM_RELEASE(),
    ADD_FILM_RELEASE: new ADD_FILM_RELEASE(),
    ON_LOAD_FILM: new ON_LOAD_FILM({ loadingAtr: "loadStatus" }),
    TOGGLE_FILM_RELEASE_FORM: new TOGGLE_FILM_RELEASE_FORM({ loadingAtr: "loadStatus" }),
    ON_CREATE_FORM_EXISTING: new ON_CREATE_FORM_EXISTING(),
    MERGE_FILM_RELEASE: new MERGE_FILM_RELEASE({ loadingAtr: "mergingStatus" }),
    ASSOCIATION_FILM_RELEASE: new ASSOCIATION_FILM_RELEASE({ loadingAtr: "associationStatus" }),
};

const handlers = createHandler(actions);

export default createReducer(initState, handlers);
